import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TBoardId } from '../../../types/types';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardSetKNBCardColorTagsSearchUsed = (
    boardId: TBoardId,
    isKNBCardColorTagsSearchUsed: boolean,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { isKNBCardColorTagsSearchUsed }));
    };
    return action;
};
